(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('macros', {
                parent: 'management',
                url: '/macros?search',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.macro.home.title'
                },
                params: {
                    repeatable: {
                        value: '-1'
                    },
                    page: {
                        value: '1',
                        squash: true
                    },
                    itemsPerPageChosen: null,
                    sort: {
                        value: [],
                        squash: true
                    },
                    predicates: {},
                    search: {
                        value: '',
                        squash: true
                    }
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/macro/macro.html',
                        controller: 'MacroController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('macro');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('queueCommand');
                        return $translate.refresh();
                    }],
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            repeatable: $stateParams.repeatable,
                            predicates: $stateParams.predicates,
                            search: $stateParams.search
                        }
                    }]
                }
            })
            .state('macro-detail', {
                parent: 'macros',
                url: '/{id}/macro-detail',
                data: {
                    authorities: ['ROLE_DOMAIN_USER']
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/macro/macro-detail.html',
                        controller: 'MacroDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('macro');
                        $translatePartialLoader.addPart('tabDeviceReleases');
                        $translatePartialLoader.addPart('queueCommand');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Macro', function ($stateParams, Macro) {
                        return Macro.get({id: $stateParams.id});
                    }]
                }
            })
            .state('macros.delete', {
                parent: 'macros',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_DOMAIN_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/macro/macro-delete-dialog.html',
                        controller: 'MacroDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Macro', function (Macro) {
                                return Macro.get({id: $stateParams.id});
                            }]
                        }
                    }).result.then(function () {
                        $state.go('macros', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
